import _ from 'lodash';

export default {
    bind(el, binding, vnode) {
        const isLoading = _.get(binding, 'value', false);

        if (isLoading) {
            if (_.get(binding.modifiers, 'block')) {
                vnode.context.$messenger.loading(el, {}, _.get(vnode, 'data.attrs.loading-message', ' '));
            } else {
                vnode.context.$messenger.loading(el);
            }
        }
    },
    update(el, binding, vnode) {
        const isLoading = _.get(binding, 'value', false);

        if (isLoading) {
            if (_.get(binding.modifiers, 'block')) {
                vnode.context.$messenger.loading(el, {}, _.get(vnode, 'data.attrs.loading-message', ' '));
            } else {
                vnode.context.$messenger.loading(el);
            }
        } else {
            vnode.context.$messenger.loaded(el);
        }
    },
};
